import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { translate } from "react-i18next";
import Typography from "@material-ui/core/Typography";
import LinearProgress from "@material-ui/core/LinearProgress";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ListSubheader from "@material-ui/core/ListSubheader";
import List from "@material-ui/core/List";
import NumberFormat from "react-number-format";
import RangeCalendar from "rc-calendar/lib/RangeCalendar";
import "rc-calendar/assets/index.css";
import DateRangeIcon from "@material-ui/icons/DateRange";
import Picker from "rc-calendar/lib/Picker";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import moment from "moment";
import Chip from "@material-ui/core/Chip";
import MobileStepper from "@material-ui/core/MobileStepper";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import SwipeableViews from "react-swipeable-views";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

import { THEME, DATE_FORMAT } from "../_constants";
import { heatmapActions } from "../_actions";
import { validateBannerData } from "../AddCampaignPage/UploadBannerComponent";
import "./Carousel.css";

const CAROUSEL_HEIGHT = 200;

const styles = theme => ({
    container: {
        width: 400,
        backgroundColor: THEME.COLOR.MAIN,
        display: "flex",
        flexDirection: "column",
        padding: 2,
        zIndex: 1,
        shadowColor: "#0f0",
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.8,
        shadowRadius: 2,
        elevation: 1,
        overflow: "auto"
    },
    group: {
        backgroundColor: "#2f3846"
    },
    infoItem: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyItems: "space-between",
        marginTop: 5,
        marginBottom: 5
    },
    infoItem_title: {
        maxWidth: 150,
        color: THEME.COLOR.GRAY
    },
    infoItem_value: {
        flex: 1,
        color: THEME.COLOR.GRAY,
        textAlign: "right"
    },
    progressBar: {
        marginLeft: 25,
        marginRight: 25,
        backgroundColor: THEME.COLOR.GRAY
    },
    field: {
        alignSelf: "center",
        alignItems: "center",
        width: "100%",
        display: "flex",
        flexDirection: "row"
    },
    dateButton: {
        width: "100%",
        margin: 0,
        padding: 10,
        textTransform: "none",
        color: THEME.COLOR.GRAY,
        borderColor: THEME.COLOR.GRAY
    },
    rightIcon: {
        marginLeft: "auto",
        marginRight: 0,
        color: THEME.COLOR.GRAY
    },
    chip: {
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        borderRadius: THEME.BORDER.RADIUS
    },
    carousel: {
        minHeight: CAROUSEL_HEIGHT,
        maxHeight: CAROUSEL_HEIGHT,
        display: "flex"
    },
    swipeable: {
        height: "100%",
        flex: "0 0 100%"
    },
    img: {
        height: CAROUSEL_HEIGHT,
        width: "100%",
        overflow: "hidden"
    },
    stepper: {
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        width: "100%",
        height: 20,
        marginLeft: "calc(-100%)",
        marginTop: CAROUSEL_HEIGHT - 35
    }
});

//#region CChip
class CustomChip extends React.Component {
    constructor(props) {
        super(props);

        this.defaultColor_Selected = THEME.COLOR.YELLOW;
        this.defaultColor_Deselected = "#2f3846";

        this.state = {
            isSelected: props.isSelected ? props.isSelected : false
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isSelected !== this.state.isSelected) {
            this.setState({ isSelected: nextProps.isSelected });
        }
    }

    toggleSelection() {
        let newState = !this.state.isSelected;
        this.setState({ isSelected: newState });

        this.props.onToggle(newState, this.props.data);
    }

    render() {
        const { classes, label, selectedColor } = this.props;

        let bgColor = this.state.isSelected
            ? selectedColor
                ? selectedColor
                : this.defaultColor_Selected
            : this.defaultColor_Deselected;

        let textColor = this.state.isSelected ? "white" : THEME.COLOR.GRAY;

        let borderColor = this.state.isSelected ? bgColor : THEME.COLOR.GRAY;

        return (
            <Chip
                label={label}
                className={classes.chip}
                style={{
                    backgroundColor: bgColor,
                    color: textColor,
                    border: `1px solid ${borderColor}`
                }}
                onClick={this.toggleSelection.bind(this)}
            />
        );
    }
}

CustomChip.propTypes = {
    classes: PropTypes.object.isRequired
};

const CChip = withStyles(styles)(CustomChip);
//#endregion CChip

//#region Carousel
class Carousel extends React.Component {
    state = {
        activeStep: 0,
        isOpenLightBox: false
    };

    handleNext = e => {
        e.stopPropagation();

        this.setState(prevState => ({
            activeStep: prevState.activeStep + 1
        }));
    };

    handleBack = e => {
        e.stopPropagation();

        this.setState(prevState => ({
            activeStep: prevState.activeStep - 1
        }));
    };

    handleStepChange = activeStep => {
        this.setState({ activeStep });
    };

    openLightBox = () => {
        // open light box
        this.setState({
            isOpenLightBox: true
        });
    };

    renderImageGallery() {
        const { activeStep, isOpenLightBox } = this.state;
        const data = this.props.fullMedias;

        return (
            <div>
                {isOpenLightBox &&
                    data && (
                        <Lightbox
                            mainSrc={data[activeStep]}
                            nextSrc={data[(activeStep + 1) % data.length]}
                            prevSrc={
                                data[
                                    (activeStep + data.length - 1) % data.length
                                ]
                            }
                            onCloseRequest={() =>
                                this.setState({ isOpenLightBox: false })
                            }
                            onMovePrevRequest={() =>
                                this.setState({
                                    activeStep:
                                        (activeStep + data.length - 1) %
                                        data.length
                                })
                            }
                            onMoveNextRequest={() =>
                                this.setState({
                                    activeStep: (activeStep + 1) % data.length
                                })
                            }
                        />
                    )}
            </div>
        );
    }

    render() {
        const { classes, theme, thumbnails } = this.props;
        const self = this;
        const state = this.state;

        //
        let disabledButton_next = state.activeStep === thumbnails.length - 1;
        let disabledButton_back = state.activeStep === 0;

        return (
            <div className={classes.carousel} onClick={this.openLightBox}>
                <SwipeableViews
                    className={classes.swipeable}
                    axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                    index={state.activeStep}
                    onChangeIndex={self.handleStepChange}
                    enableMouseEvents
                >
                    {thumbnails.map((imgUrl, index) => (
                        <img
                            key={index}
                            className={classes.img}
                            src={imgUrl}
                            alt={"Banner"}
                        />
                    ))}
                </SwipeableViews>
                <MobileStepper
                    steps={thumbnails.length}
                    position="static"
                    activeStep={state.activeStep}
                    className={classes.stepper}
                    nextButton={
                        <IconButton
                            style={{
                                color: disabledButton_next
                                    ? THEME.COLOR.GRAY
                                    : "white"
                            }}
                            size="small"
                            onClick={event => self.handleNext(event)}
                            disabled={disabledButton_next}
                        >
                            {theme.direction === "rtl" ? (
                                <KeyboardArrowLeft />
                            ) : (
                                <KeyboardArrowRight />
                            )}
                        </IconButton>
                    }
                    backButton={
                        <IconButton
                            style={{
                                color: disabledButton_back
                                    ? THEME.COLOR.GRAY
                                    : "white"
                            }}
                            size="small"
                            onClick={event => self.handleBack(event)}
                            disabled={disabledButton_back}
                        >
                            {theme.direction === "rtl" ? (
                                <KeyboardArrowRight />
                            ) : (
                                <KeyboardArrowLeft />
                            )}
                        </IconButton>
                    }
                />
                {this.renderImageGallery()}
            </div>
        );
    }
}

Carousel.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired
};

const CCarousel = withStyles(styles, { withTheme: true })(Carousel);
//#endregion CChip

//#region DateTime Helper
const now = moment();
//#endregion DateTime Helper

class Filter extends React.Component {
    //#region Life cycle
    constructor(props) {
        super(props);

        let campaign = props.campaign;
        this.state = this.getDefaultStateForCampaign(campaign);
    }

    componentDidMount() {
        this.updateFilterWithState(this.state);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.campaign.id !== this.props.campaign.id) {
            let campaign = nextProps.campaign;

            this.setState(this.getDefaultStateForCampaign(campaign));
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            prevState.selectedDateRange !== this.state.selectedDateRange ||
            prevState.selectedTimeSlots !== this.state.selectedTimeSlots ||
            prevState.selectedZones !== this.state.selectedZones
        ) {
            this.updateFilterWithState(this.state);
        }
    }
    convertDate(date){  //DD/MM/YYYY  => MM/DD/YYYY
        let d= date.split("/")
        let convDate =d[1]+"/"+d[0]+"/"+d[2]
        return moment(convDate)
    }
    getDefaultStateForCampaign(campaign) {
        let startDate = this.convertDate(campaign.startDate)
        let endDate = this.convertDate(campaign.endDate)
        let defaultDateRange = [startDate, endDate];
        let defaultSelectedTimeSlots = campaign.params.timeSlots.slice();
        let defaultSelectedZones = campaign.params.zones.slice();

        let state = {
            selectedDateRange: defaultDateRange,
            hoverDateValue: defaultDateRange,
            selectedTimeSlots: defaultSelectedTimeSlots,
            selectedZones: defaultSelectedZones
        };

        return state;
    }
    //#endregion Life cycle

    //#region actions
    //#region Filter
    //#region date range
    onChangeSelectedDateRange = selectedDateRange => {
        this.setState({ selectedDateRange });
    };

    onHoverChangeDate = hoverDateValue => {
        this.setState({ hoverDateValue });
    };
    //#endregion date range

    toogleSelectionTimeSlot(isSelected, timeSlot) {
        if (isSelected) {
            let newSelectedTimeSlots = this.state.selectedTimeSlots.slice();
            newSelectedTimeSlots.push(timeSlot);
            this.setState({ selectedTimeSlots: newSelectedTimeSlots });
        } else {
            let index = this.state.selectedTimeSlots.findIndex(
                element =>
                    element.start === timeSlot.start &&
                    element.end === timeSlot.end
            );
            if (index !== -1) {
                let newSelectedTimeSlots = this.state.selectedTimeSlots.slice();
                newSelectedTimeSlots.splice(index, 1);

                this.setState({
                    selectedTimeSlots: newSelectedTimeSlots
                });
            } else {
            }
        }
    }

    toogleSelectionZone(isSelected, zone) {
        if (isSelected) {
            let newSelectedZones = this.state.selectedZones.slice();
            newSelectedZones.push(zone);
            this.setState({ selectedZones: newSelectedZones });
        } else {
            let index = this.state.selectedZones.findIndex(element => {
                return element.code === zone.code || element.id === zone.id;
            });
            if (index !== -1) {
                let newSelectedZones = this.state.selectedZones.slice();
                newSelectedZones.splice(index, 1);

                this.setState({ selectedZones: newSelectedZones });
            } else {
            }
        }
    }

    getFilterFromState(state) {
        let campaign = this.props.campaign;

        let startDateStr = state.selectedDateRange[0].format(DATE_FORMAT);
        let endDateStr = state.selectedDateRange[1].format(DATE_FORMAT);

        let zonesObj = {};
        state.selectedZones.map(zone => {
            zonesObj[zone.code] = {
                id: zone.id,
                inMoney: zone.inMoney,
                outMoney: zone.outMoney
            };

            return zone;
        });

        let timeSlots = state.selectedTimeSlots.map(timeSlot => {
            return {
                start: timeSlot.start,
                end: timeSlot.end,
                zones: zonesObj
            };
        });

        let filter = {
            campaignID: campaign.id,
            startDate: startDateStr,
            endDate: endDateStr,
            timeSlots: timeSlots
        };

        return filter;
    }

    updateFilterWithState(state) {
        let filter = this.getFilterFromState(state);

        this.props.dispatch(heatmapActions.getHeatmap(filter));
    }
    //#endregion Filter
    //#endregion actions

    render() {
        const { t, classes, campaign } = this.props;
        const self = this;
        const state = this.state;

        function renderCarousel() {
            let thumbnails = [];
            let fullMedias = [];

            function getThumbnailUrlOfBanner(bannerData) {
                let result = validateBannerData(bannerData)
                    ? bannerData.thumbnail_medium
                    : null;

                return result;
            }

            function getUrlOfBanner(bannerData) {
                let result = validateBannerData(bannerData)
                    ? bannerData.url
                    : null;

                return result;
            }

            let { img1, img2, img3, video } = campaign;
            let thumbnail1 = getThumbnailUrlOfBanner(img1);
            let thumbnail2 = getThumbnailUrlOfBanner(img2);
            let thumbnail3 = getThumbnailUrlOfBanner(img3);
            let thumbnailVideo = getThumbnailUrlOfBanner(video);

            let mediaUrl1 = getUrlOfBanner(img1);
            let mediaUrl2 = getUrlOfBanner(img2);
            let mediaUrl3 = getUrlOfBanner(img3);
            let mediaUrlVideo = getUrlOfBanner(video);

            if (validateBannerData(video)) {
                thumbnails = [thumbnailVideo];
                fullMedias = [mediaUrlVideo];
            } else {
                if (thumbnail1) {
                    thumbnails.push(thumbnail1);
                    fullMedias.push(mediaUrl1);
                }
                if (thumbnail2) {
                    thumbnails.push(thumbnail2);
                    fullMedias.push(mediaUrl2);
                }
                if (thumbnail3) {
                    thumbnails.push(thumbnail3);
                    fullMedias.push(mediaUrl3);
                }
            }

            return (
                <CCarousel thumbnails={thumbnails} fullMedias={fullMedias} />
            );
        }

        function renderSummary() {
            function formatNumber(value) {
                return (
                    <NumberFormat
                        value={value ? value : "-"}
                        displayType={"text"}
                        thousandSeparator={"."}
                        decimalSeparator={","}
                        renderText={value => value}
                    />
                );
            }

            function renderProgress(title, value, total, color) {
                return (
                    <List
                        component="nav"
                        subheader={
                            <ListSubheader
                                component="div"
                                className={classes.infoItem}
                            >
                                <Typography
                                    variant="body2"
                                    className={classes.infoItem_title}
                                >
                                    {title}
                                </Typography>

                                <Typography className={classes.infoItem_value}>
                                    {formatNumber(value)} /{" "}
                                    {formatNumber(total)}
                                </Typography>
                            </ListSubheader>
                        }
                    >
                        <LinearProgress
                            className={classes.progressBar}
                            color={color}
                            variant="determinate"
                            value={(value * 100) / total}
                        />
                    </List>
                );
            }

            function renderInfo(title, value, style = null) {
                return (
                    <List
                        component="nav"
                        style={style}
                        subheader={
                            <ListSubheader
                                component="div"
                                className={classes.infoItem}
                            >
                                <Typography
                                    variant="body2"
                                    className={classes.infoItem_title}
                                >
                                    {title}
                                </Typography>
                                <Typography className={classes.infoItem_value}>
                                    {formatNumber(value)}
                                </Typography>
                            </ListSubheader>
                        }
                    />
                );
            }

            return (
                <div
                    className={classes.group}
                    style={{
                        paddingTop: 20,
                        paddingBottom: 12
                    }}
                >
                    {renderProgress(
                        t("Cost"),
                        campaign.usedBudget,
                        campaign.budget,
                        "secondary"
                    )}
                    {renderProgress(
                        t("Displays"),
                        campaign.countDisplay,
                        campaign.needDisplay,
                        "primary"
                    )}
                    {renderInfo(t("ExpectedImpressions"), campaign.impression, {
                        marginTop: 10,
                        marginBottom: -15
                    })}
                    {renderInfo(t("Impressions"), campaign.currentImpression)}
                </div>
            );
        }

        function renderExpansionPanel(title, content) {
            return (
                <ExpansionPanel
                    defaultExpanded
                    className={classes.group}
                    style={{ marginTop: 3, marginBottom: 0 }}
                >
                    <ExpansionPanelSummary
                        expandIcon={
                            <ExpandMoreIcon
                                style={{ color: THEME.COLOR.GRAY }}
                            />
                        }
                    >
                        <Typography
                            variant="body2"
                            className={classes.infoItem_title}
                        >
                            {title}
                        </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>{content}</ExpansionPanelDetails>
                </ExpansionPanel>
            );
        }

        function renderDateRangeInput() {
            const calendar = (
                <RangeCalendar
                    hoverValue={state.hoverDateValue}
                    onHoverChange={self.onHoverChangeDate}
                    showWeekNumber={false}
                    dateInputPlaceholder={[t("FromDate"), t("ToDate")]}
                    defaultValue={[now, now.clone().add(1, "months")]}
                />
            );

            function renderDateRange(startDate = null, endDate = null) {
                function renderCalendarButton(title, action) {
                    return (
                        <Button
                            variant="outlined"
                            className={classes.dateButton}
                        >
                            {title}
                            <DateRangeIcon className={classes.rightIcon} />
                        </Button>
                    );
                }

                let fromDateStr =
                    startDate == null
                        ? t("FromDate")
                        : startDate.format(DATE_FORMAT);
                let toDateStr =
                    endDate == null ? t("ToDate") : endDate.format(DATE_FORMAT);

                return (
                    <div className={classes.field}>
                        {renderCalendarButton(fromDateStr, null)}
                        <div
                            style={{
                                flexBasis: 50,
                                textAlign: "center",
                                color: THEME.COLOR.GRAY
                            }}
                        >
                            -
                        </div>
                        {renderCalendarButton(toDateStr, null)}
                    </div>
                );
            }

            return (
                <Picker
                    value={state.selectedDateRange}
                    onChange={self.onChangeSelectedDateRange}
                    animation="slide-up"
                    calendar={calendar}
                >
                    {({ value }) => {
                        return renderDateRange(value[0], value[1]);
                    }}
                </Picker>
            );
        }

        function renderTimeSlots() {
            return (
                <div>
                    {campaign.params.timeSlots.map(timeSlot => {
                        // let isSelected =
                        //     state.selectedTimeSlots.indexOf(timeSlot) > -1;
                        let label = `${timeSlot.start} - ${timeSlot.end}`;
                        let found = state.selectedTimeSlots.filter(
                            item =>
                                item.start === timeSlot.start &&
                                item.end === timeSlot.end
                        );
                        let isSelected = found.length > 0;

                        return (
                            <CChip
                                key={label}
                                isSelected={isSelected}
                                label={label}
                                data={timeSlot}
                                selectedColor={THEME.COLOR.GREEN}
                                onToggle={(isSelected, timeSlot) =>
                                    self.toogleSelectionTimeSlot(
                                        isSelected,
                                        timeSlot
                                    )
                                }
                            />
                        );
                    })}
                </div>
            );
        }

        function renderZones() {
            return (
                <div>
                    {campaign.params.zones.map(zone => {
                        // let isSelected = state.selectedZones.indexOf(zone) > -1;
                        let found = state.selectedZones.filter(
                            item => item.id === zone.id
                        );
                        let isSelected = found.length > 0;
                        let label = zone.name;

                        return (
                            <CChip
                                key={zone.id}
                                isSelected={isSelected}
                                label={label}
                                data={zone}
                                onToggle={(isSelected, zone) =>
                                    self.toogleSelectionZone(isSelected, zone)
                                }
                            />
                        );
                    })}
                </div>
            );
        }

        return (
            <div className={classes.container}>
                {renderCarousel()}
                {renderSummary()}

                {renderExpansionPanel(t("Date"), renderDateRangeInput())}
                {renderExpansionPanel(t("RangeTime"), renderTimeSlots())}
                {renderExpansionPanel(t("Zone"), renderZones())}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {};
}

const connectedFilter = connect(mapStateToProps)(Filter);

export default withStyles(styles)(translate("translations")(connectedFilter));



// WEBPACK FOOTER //
// ./src/CampaignDetailPage/Filter.js